import Flickity from 'flickity';

const carousels = [];

const init = () => {
  carousels.forEach((carousel) => {
    try {
      carousel.destroy();
    } catch (error) {
      console.log('err:', error);
    }
  });

  carousels.length = 0;

  if (window.innerWidth > 767) {
    return;
  }

  document.querySelectorAll('[blog-latest-pods-carousel]').forEach((el) => {
    const carousel = new Flickity(el, {});
    carousels.push(carousel);
  });
};

const resizeHandler = () => {
  clearTimeout(resizeHandler.debounce);
  resizeHandler.debounce = setTimeout(() => {
    init();
  }, 250);
};

export default function () {
  if (document.querySelectorAll('[blog-latest-pods-carousel]').length === 0) {
    return;
  }

  init();
  window.addEventListener('resize', resizeHandler);
}
